module.exports = __webpack_public_path__ + "static/img/100596.c02b86db.png";